import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "support-video-card__img-wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "support-video-card__icon-opaque-circle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-play support-video-card__icon" })
], -1 /* HOISTED */)
const _hoisted_5 = { class: "support-video-card__text-content" }
const _hoisted_6 = { class: "support-video-card__title" }
const _hoisted_7 = { class: "support-video-card__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: "support-video-card js-video",
    href: `https://www.youtube.com/watch?v=${$props.youtubeID}`
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["support-video-card__visual-content", $props.portfolio ? `support-video-card__visual-content--${$props.portfolio}` : ''])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: $props.thumbnailImageUrl ? $props.thumbnailImageUrl : `https://img.youtube.com/vi/${$props.youtubeID}/mqdefault.jpg`,
          alt: "product image",
          class: "support-video-card__img"
        }, null, 8 /* PROPS */, _hoisted_3)
      ]),
      _hoisted_4
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString($props.title), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_7, _toDisplayString($props.videoDescription), 1 /* TEXT */)
    ])
  ], 8 /* PROPS */, _hoisted_1))
}